import axios from "axios";

interface IGetRulesMailingListReturn {
    mailingList: string[]
}

export const getRulesMailingList = async (): Promise<IGetRulesMailingListReturn> => {
    const response = await axios.get('/booking/rule/mailing-list');
    return response.data;
};

export default getRulesMailingList;